import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../../helpers/settingsInfoBox';

/*
 * Consts.
 */

const infoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_RULES,
  title: <Trans id="settings-rules-infobox-title">Rules</Trans>,
  body: (
    <Trans id="settings-rules-infobox-body">
      <p>Rules save you time by automating repetitive processes.</p>
      <p>
        For example, you can create a rule to assign incoming messages to specific teammates, add tags to
        certain types of conversations, or always reply with a message template.
      </p>
    </Trans>
  ),
  link: 'https://help.frontapp.com/t/h461c6/understanding-rules',
};

/*
 * Hook.
 */

export function useRuleListInfoBox() {
  return useSettingsInfoBox(infoBoxProps);
}
